var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{attrs:{"id":"CITA"}},[_c('VHeader',{attrs:{"footnotes":_vm.footnotes}}),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view',{attrs:{"footnotes":_vm.footnotes}})],1),_c('div',{staticClass:"offset-top-6"},[_c('VFootnotes',{attrs:{"footnotes":_vm.footnotes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }